export const getDateNow = (): Date => new Date();
